import React from 'react'

import { ReactComponent as LirariLandingPageMobileLogo } from './../../assets/images/lirari-landing-page-mobile-logo.svg'
import { useAuth0 } from '@auth0/auth0-react'
import './loginPage.css'

const LoginPage = () => {
  const { loginWithRedirect } = useAuth0()

  return (
    <div className="bg-white flex flex-col h-[100vh]">
      <div className="flex flex-row items-center justify-center">
        <LirariLandingPageMobileLogo className="h-[25rem]" />
      </div>
      <div className="flex flex-row justify-center items-center">
        <div className="flex flex-col justify-center items-center">
          <p className="text-[55px] lg:text-[70px] text-black m-0">lirari</p>
          <p className="text-[20px] lg:text-[25px] text-black m-0">The Professional</p>
          <p className="text-[20px] lg:text-[25px] text-black m-0">Musician Network</p>
        </div>
      </div>

      <div className="flex lg:flex-row flex-col h-[50vh] lg:justify-center lg:items-start items-center lg:space-x-2 lg:space-y-0 space-y-2 pt-5">
        <button className="log-in-button log-in-text justify-center items-center" onClick={() => loginWithRedirect()}>
          <div>SIGN UP</div>
        </button>
        <button className="log-in-button log-in-text justify-center items-center" onClick={() => loginWithRedirect()}>
          <div>LOG IN</div>
        </button>
      </div>
    </div>
  )
}

export default LoginPage
